import { ChangeEvent, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import './styles.css';
import { ErrorMessage } from '@/components/Message/ErrorMessage';

export type Options = {
  label: string;
  value: string;
  color?: string;
};

interface SelectProps
  extends React.PropsWithRef<JSX.IntrinsicElements['select']> {
  containerClassName?: string;
  selectClassName?: string;
  placeholder?: string;
  label?: string;
  options: Options[];
  name?: string;
  value?: string;
  defaultValue?: string;
  disabled?: boolean;
  errorMessage?: string;
  onChange?: (e: ChangeEvent<HTMLSelectElement>) => void;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  (
    {
      containerClassName,
      selectClassName,
      placeholder,
      label,
      options,
      name,
      value,
      disabled,
      errorMessage,
      onChange,
      ...rest
    },
    ref
  ) => {
    return (
      <div
        className={twMerge(
          'select-container flex flex-1 flex-col gap-0.75',
          containerClassName
        )}
      >
        <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
          {label && <label className="form-label max-w-56">{label}</label>}
          <div className="grow">
            <select
              ref={ref}
              className={twMerge(
                'select text-gray-484848 font-normal leading-loose bg-gray-100 pr-8 dark-mode:text-gray-600',
                errorMessage &&
                  'border-danger hover:border-danger focus:border-danger',
                selectClassName
              )}
              name={name}
              onChange={onChange}
              value={value}
              disabled={disabled}
              {...rest}
            >
              {placeholder && <option value="">{placeholder}</option>}
              {options?.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        {errorMessage && <ErrorMessage message={errorMessage} />}
      </div>
    );
  }
);
